import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import { PAGES } from 'constants/pages';

import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { Header, HeaderTitle } from 'components/Header';
import { PageTitle } from 'components/PageTitle';
import { SubventionsList } from './components/SubventionsList';
import { TotadminPermission } from 'data/__generated__';

export const Subventions = () => {
    return (
        <Container>
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.subventions} />
                </HeaderTitle>
                <Link to="/subvention/create">
                    <TotemPrimaryButton requiredPermissions={[TotadminPermission.SubventionsManage]}>
                        Créer une subvention
                    </TotemPrimaryButton>
                </Link>
            </Header>
            <Content>
                <ListContainer>
                    <SubventionsList />
                </ListContainer>
            </Content>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
    background-color: ${({ theme }) => theme.backgroundColor};
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    padding: 15px;
    flex: 1;
    overflow: hidden;
`;

const ListContainer = styled.div`
    flex: 1;
    overflow: hidden;
`;
